import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useSiteConfig() {
  return useQuery({
    queryKey: ["site-config"],
    queryFn: () => api.get("/config").then((r) => r.data),
    staleTime: 30_000,
  });
}
